/**
 * IMPORTS
 */
import JSZip from "jszip";

import {
  getZipEntryFileName,
  isValidImageExtension,
  shouldIgnoreZipEntry,
} from "@pages/client/details-model/view-model/helpers/zip-entry-filter";

/**
 * Conta a quantidade de imagens válidas dentro do ZIP.
 *
 * Regras:
 * - Ignora diretórios
 * - Ignora metadados do macOS
 * - Considera apenas extensões válidas
 */
async function countValidImageFilesFromZip(zipFile: File | Blob): Promise<number> {
  const zipInstance = await new JSZip().loadAsync(zipFile);

  let totalValidImages = 0;

  for (const [zipEntryPath, zipEntry] of Object.entries(zipInstance.files)) {
    const isDirectory = (zipEntry as JSZip.JSZipObject).dir;

    if (shouldIgnoreZipEntry(zipEntryPath, isDirectory)) {
      continue;
    }

    const fileName = getZipEntryFileName(zipEntryPath);
    if (!isValidImageExtension(fileName)) {
      continue;
    }

    totalValidImages++;
  }

  return totalValidImages;
}

/**
 * EXPORTS
 */
export { countValidImageFilesFromZip };
